import { IdSchema } from "@uzverse/core";
import { z } from "zod";
export const MATERIAL_PRESETS = [
    "plaster",
    "brick",
    "concrete",
    "glass",
    "wood",
    "metal",
    "stone",
    "grass",
    "asphalt",
    "water",
];
export const MaterialPresetSchema = z.enum(MATERIAL_PRESETS);
/** A surface look: a preset, a color, PBR scalars or a texture asset; at least one field. */
export const MaterialSpecSchema = z
    .object({
    preset: MaterialPresetSchema.optional(),
    color: z
        .string()
        .regex(/^#[0-9a-f]{6}$/i)
        .optional(),
    roughness: z.number().min(0).max(1).optional(),
    metalness: z.number().min(0).max(1).optional(),
    opacity: z.number().min(0.05).max(1).optional(),
    /** A `world.asset` with an image media type. */
    textureAssetId: IdSchema.optional(),
    repeat: z.tuple([z.number().positive(), z.number().positive()]).optional(),
})
    .refine((m) => Object.keys(m).length > 0, "empty material");
//# sourceMappingURL=materials.js.map